import React, { useContext } from 'react';
import { Avatar } from 'antd';
import { UserOutlined } from '@ant-design/icons';

import { UserContext } from '../../providers/UserProvider';

const FallbackAvatar = () => {
    const context = useContext(UserContext);
    const user = context.user;

    let initial = null;

    if (user) {
        const name = user?.displayName;
        const email = user?.email;

        if (name) {
            initial = name.charAt(0).toUpperCase();
        } else if (email) {
            initial = email.charAt(0).toUpperCase();
        }
    }

    return (
        <Avatar
            style={{
                backgroundColor: '#7265e6',
                verticalAlign: 'middle',
            }}
            shape="circle"
            size="small"
            gap={12}
            icon={!initial ? <UserOutlined /> : undefined}
        >
            {initial}
        </Avatar>
    );
};

export default FallbackAvatar;